import { PositionConfigInterface } from 'types/store';

export const defaultPositionConfig: PositionConfigInterface = { x: 15, y: 15 };
export const defaultZoom = 1;
